import React from 'react';
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import {
  CalendarHeatMap,
  Time,
  Location,
  Enterprise,
  Group,
  Headset,
  Document,
  Headphones,
  UserFollow
} from '@carbon/icons-react';


const renderCalendar = () => {

  return ""
  /*const startDay=props.row.DateSession;
  const startTime=props.row.TimeSession        
  let startSession=startDay.split("/").reverse().join("-")
  startSession=startSession+"T"+startTime+"+03:00"

  const endDay=props.row.EndDaySession;
  const endTime=props.row.EndTimeSession;
  let endSession=endDay.split("/").reverse().join("-")
  endSession=endSession+"T"+endTime+"+03:00"
 

 const event = {
   title: "[PP-22] "+props.row.MonitorTitle,
   description: props.row.MonitorTitle,
   startTime: startSession,
   endTime: endSession,
   location:props.row.RoomName
   }

 //console.log(event)


  return props.formattedValue ? (
    <div className="calendar-div">
<ICalendarLink event={event}> <FontAwesomeIcon icon={faCalendar} /></ICalendarLink>

    </div>

  ) : (
    <div className="fake-avatar">
      <FontAwesomeIcon icon={faUser} />
    </div>
  );*/
};

export const ColumnsSessions = [
  { field: 'MonitorTitle', headerName: 'Session title', width: 400 },
  { field: 'AgendaItems', headerName: ' Agenda Item(s)', width: 120 },
  { field: 'TimeSessionStartEnd', headerName: 'Time', width: 150 },
  { field: 'DateSession', headerName: 'Date', width: 120 },  
  { field: 'CommitteeSubGroup', headerName: ' Committee(s) / Sub-group(s)', width: 130 },
  { field: 'RoomName', headerName: 'Room', width: 120 },
  { field: 'Building', headerName: 'Building', width: 120 },
  { field: 'MeetingType', headerName: 'Type', width: 120 },
  { field: 'Message', headerName: 'Invitation to', width: 150 },
  { field: 'Notes', headerName: 'Notes', width: 150 },
  {
    field: "actions",
    headerName: "Links",
    width: 120,
    sortable: false,
    disableColumnMenu: true,
    renderCell: (params: any) => {
      //console.log(params)

      return (

        <Box
          sx={{
            // backgroundColor: "whitesmoke",
            width: "100%",
            height: "100%",
            display: "flex",
            marginRight: "100%",
            justifyContent: "center",
            alignItems: "center"
          }}
        >

          {/** Agenda */}
          {params.row.DocumentNumber !== undefined &&
            params.row.DocumentNumber !== '' ? (
            <>
              {/* adding space */}

              <a title='Download agenda' className="ituBtn" href={'https://www.itu.int/md/' + params.row.DocumentNumber} target="_blank" rel="noreferrer" style={{ padding: '0.1rem 0.3rem', paddingTop: '8px', border: '1px solid #0076a1', display: 'initial' }}><Document style={{ fill: '#009cd6', margin: '0px' }} /></a>
            </>
          ) : null}


          {/** joinURL */}
          {params.row.JoinURL !== undefined &&
            params.row.JoinURL !== '' ? (
            <>
              {/* adding space */}
              {'\u00A0'}
              {'\u00A0'}

              <a title='Join' className="ituBtn" href={params.row.JoinURL} target="_blank" rel="noreferrer" style={{ padding: '0.1rem 0.3rem', paddingTop: '8px', border: '1px solid #0076a1', display: 'initial' }}><Headset style={{ fill: '#009cd6', margin: '0px' }} /></a>
            </>

          ) : null}


          {/** RegisterURL */}
          {params.row.RegisterURL !== undefined &&
            params.row.RegisterURL !== '' ? (
            <>
              {/* adding space */}
              {'\u00A0'}
              {'\u00A0'}

              <a title='Register' className="ituBtn" href={params.row.RegisterURL} target="_blank" rel="noreferrer" style={{ padding: '0.1rem 0.3rem', paddingTop: '8px', border: '1px solid #0076a1', display: 'initial' }}><UserFollow style={{ fill: '#009cd6', margin: '0px' }} /></a>
            </>
          ) : null}





        </Box>
      );

    }
  },

  {
    field: 'CalendarDate',
    headerName: '',
    width: 50,
    renderCell: renderCalendar,
  }
];

